var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 5.5,
    stroke: "#424242",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.7676,
    y: 21.6191,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(135 22.7676 21.6191)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.83008,
    y: 6.67969,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(135 7.83008 6.67969)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 13.8125,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-90 0 13.8125)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.125,
    y: 13.8125,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-90 21.125 13.8125)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.38281,
    y: 22.7676,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-135 4.38281 22.7676)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3203,
    y: 7.83008,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-135 19.3203 7.83008)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8125,
    y: 26,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-180 13.8125 26)",
    fill: "#424242",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8145,
    y: 4.875,
    width: 1.625,
    height: 4.875,
    rx: 0.8125,
    transform: "rotate(-180 13.8145 4.875)",
    fill: "#424242",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIndicator);
export default __webpack_public_path__ + "static/media/LightIndicator.fdade37a98d2fc1898d834d8b7056f82.svg";
export { ForwardRef as ReactComponent };